/* Organik theme scripts */
(function () {
  'use strict';

  var money = function (cents) { return '$' + (cents / 100).toFixed(2); };

  /* ---- mobile menu ---- */
  document.addEventListener('click', function (e) {
    var toggle = e.target.closest('[data-menu-toggle]');
    if (!toggle) return;
    var list = document.querySelector('[data-menu]');
    if (!list) return;
    var open = list.classList.toggle('open');
    toggle.setAttribute('aria-expanded', open ? 'true' : 'false');
  });

  /* ---- tab groups: pill tabs AND numbered tabs ---- */
  document.querySelectorAll('[data-tabs]').forEach(function (group) {
    group.addEventListener('click', function (e) {
      var tab = e.target.closest('.tab, .numtab');
      if (!tab || !group.contains(tab)) return;
      e.preventDefault();

      var scope = group.closest('[data-tab-scope]') || document;
      group.querySelectorAll('.tab, .numtab').forEach(function (b) {
        b.setAttribute('aria-selected', 'false');
      });
      tab.setAttribute('aria-selected', 'true');

      var target = tab.getAttribute('data-panel');
      scope.querySelectorAll('[data-panel-body]').forEach(function (panel) {
        panel.hidden = panel.getAttribute('data-panel-body') !== target;
      });
    });
  });

  /* ---- product gallery ---- */
  document.querySelectorAll('[data-gallery]').forEach(function (gallery) {
    var main = gallery.querySelector('[data-gallery-main]');
    gallery.addEventListener('click', function (e) {
      var thumb = e.target.closest('[data-gallery-thumb]');
      if (!thumb || !main) return;
      main.src = thumb.getAttribute('data-full');
      main.alt = thumb.getAttribute('data-alt') || '';
      gallery.querySelectorAll('[data-gallery-thumb]').forEach(function (b) {
        b.setAttribute('aria-current', 'false');
      });
      thumb.setAttribute('aria-current', 'true');
    });
  });

  /* ---- quantity steppers ---- */
  document.addEventListener('click', function (e) {
    var step = e.target.closest('[data-qty-step]');
    if (!step) return;
    var box = step.closest('.qty');
    var input = box && box.querySelector('input');
    if (!input) return;
    var next = parseInt(input.value, 10) + parseInt(step.getAttribute('data-qty-step'), 10);
    input.value = Math.max(parseInt(input.min || '1', 10), next);
    input.dispatchEvent(new Event('change', { bubbles: true }));
  });

  /* ---- variant selection ---- */
  document.querySelectorAll('[data-variant-form]').forEach(function (form) {
    var data = form.querySelector('[data-variant-json]');
    if (!data) return;
    var variants = JSON.parse(data.textContent);
    var idField = form.querySelector('[name="id"]');
    var priceEl = form.querySelector('[data-price]');
    var compareEl = form.querySelector('[data-compare]');
    var button = form.querySelector('[data-add]');

    /* The store-wide promotion is an automatic discount, so it is not part of
       the variant data Shopify gives us. Liquid renders the first variant's
       promotional figures on page load and hands the percentage down here so
       switching size does not silently revert the price to full. Must stay
       equal to settings.promo_percent, which snippets/promo-price.liquid
       uses. Zero when the promotion is off or the visitor is outside the
       countries it applies to. */
    var promo = parseFloat(form.getAttribute('data-promo') || '0');
    if (!(promo > 0 && promo < 100)) promo = 0;

    var sync = function () {
      var chosen = Array.prototype.map.call(
        form.querySelectorAll('[data-option]:checked'),
        function (i) { return i.value; }
      );
      var match = variants.filter(function (v) {
        return v.options.every(function (o, i) { return o === chosen[i]; });
      })[0];
      if (!match || !idField) return;
      idField.value = match.id;

      var live = match.price;
      var was = (match.compare_at_price && match.compare_at_price > match.price)
        ? match.compare_at_price
        : 0;

      if (promo) {
        live = Math.round(match.price * (100 - promo) / 100);
        /* with no existing markdown, the full price becomes the struck one */
        if (!was) was = match.price;
      }

      if (priceEl) priceEl.textContent = money(live);
      if (compareEl) {
        if (was) {
          compareEl.textContent = money(was);
          compareEl.hidden = false;
          if (priceEl) priceEl.classList.add('sale');
        } else {
          compareEl.hidden = true;
          if (priceEl) priceEl.classList.remove('sale');
        }
      }
      if (button) {
        button.disabled = !match.available;
        button.textContent = match.available
          ? button.getAttribute('data-label-add')
          : button.getAttribute('data-label-sold');
      }
      if (history.replaceState) {
        var url = new URL(window.location.href);
        url.searchParams.set('variant', match.id);
        history.replaceState({}, '', url.toString());
      }
    };

    form.addEventListener('change', function (e) {
      if (e.target.matches('[data-option]')) sync();
    });
    sync();
  });

  /* ---- add a whole routine to the bag ---- */
  document.querySelectorAll('[data-add-all]').forEach(function (button) {
    button.addEventListener('click', function () {
      var ids = (button.getAttribute('data-variants') || '').split(',').filter(Boolean);
      if (!ids.length) return;
      var original = button.querySelector('[data-add-all-label]');
      var text = original ? original.textContent : '';
      if (original) original.textContent = 'Adding…';
      fetch(window.Shopify.routes.root + 'cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          items: ids.map(function (id) { return { id: Number(id), quantity: 1 }; })
        })
      })
        .then(function (r) { return r.json(); })
        .then(function () {
          if (original) original.textContent = 'Added';
          refreshBagCount();
          setTimeout(function () { if (original) original.textContent = text; }, 1800);
        })
        .catch(function () {
          if (original) original.textContent = 'Could not add, try again';
          setTimeout(function () { if (original) original.textContent = text; }, 2400);
        });
    });
  });

  function refreshBagCount() {
    fetch(window.Shopify.routes.root + 'cart.js')
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        document.querySelectorAll('[data-bag-count]').forEach(function (el) {
          el.textContent = cart.item_count;
        });
      })
      .catch(function () {});
  }

  /* ---- cart line quantity ---- */
  document.querySelectorAll('[data-cart-line]').forEach(function (line) {
    var input = line.querySelector('input[name="updates[]"]');
    if (!input) return;
    input.addEventListener('change', function () {
      var form = line.closest('form');
      if (form) form.submit();
    });
  });
})();
